"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconEmailSettings = void 0;
var React = __importStar(require("react"));
var IconEmailSettings = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M20.5,7 C20.534,7 20.563,7.013 20.596,7.02 L13.341,13.307 C12.753,13.792 11.248,13.792 10.664,13.312 L3.404,7.02 C3.437,7.013 3.466,7 3.5,7 L20.5,7 Z M14.987,12.541 L20.971,7.355 C20.985,7.402 21,7.449 21,7.5 L21,16.5 C21,16.602 20.962,16.691 20.909,16.771 L14.987,12.541 Z M9.4,12.878 L10.341,13.693 C10.729,14.012 11.362,14.171 11.998,14.171 C12.635,14.171 13.273,14.011 13.664,13.688 L14.6,12.878 L20.37,17 L3.63,17 L9.4,12.878 Z M3,16.5 L3,7.5 C3,7.449 3.015,7.402 3.029,7.356 L9.012,12.542 L3.091,16.771 C3.038,16.691 3,16.602 3,16.5 L3,16.5 Z M20.5,6 L3.5,6 C2.673,6 2,6.673 2,7.5 L2,16.5 C2,17.327 2.673,18 3.5,18 L20.5,18 C21.327,18 22,17.327 22,16.5 L22,7.5 C22,6.673 21.327,6 20.5,6 L20.5,6 Z" }))); };
exports.IconEmailSettings = IconEmailSettings;
exports.IconEmailSettings.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconEmailSettings;
